import { Line } from '@react-three/drei';
import * as THREE from 'three';
import ProductClearanceLabel from './ProductClearanceLabel';
import { useNavigation } from '../../function/navigation';
import { UnitConversion } from '../../inputs/UnitConversion';

function UpperEndView({
  result,
  convRatio,
  drawingBaseDimensions,
  unitSystem,
}) {
  const { nav } = useNavigation();
  const d = drawingBaseDimensions;

  const z = convRatio * d.column_centre_to_inside_outer_guide * 1.1;
  const targetY = convRatio * d.h3;
  const textSize = 20 / d.nbr_windings;

  const isReverse = ['A', 'C', 'E', 'G', 'L'].includes(d.configuration);
  const reverseMultiplier = isReverse ? -1 : 1;

  const configurationAngleRadians = THREE.MathUtils.degToRad(
    isReverse ? d.configuration_angle : 360 - d.configuration_angle
  );

  const u1 = convRatio * d.u1 * reverseMultiplier;
  const ueAngular = convRatio * d.ue_angular * reverseMultiplier;
  const ueDoubleBend = convRatio * d.ue_double_bend_value * reverseMultiplier;
  const u2 = convRatio * d.u2_value * reverseMultiplier;

  const renderLine = (start, end, verticalOffset, color) => (
    <Line
      points={[
        [start, verticalOffset, z],
        [end, verticalOffset, z],
      ]}
      color={color}
      lineWidth={3}
    />
  );

  const renderValueLabel = (x, y, value, color, field) => {
    const { displayedValue } = UnitConversion(value, unitSystem, 'mm');
    return (
      <group position={[x, y, z]}>
        <ProductClearanceLabel
          value={displayedValue}
          reverseConfig={-1}
          textSize={textSize}
          color={color}
          focus={nav.focusedInput === field}
        />
      </group>
    );
  };

  return (
    <group
      rotation={[0, -configurationAngleRadians + Math.PI / 2, 0]}
      position={[0, targetY, 0]}
    >
      {renderLine(0, u1, 0.1 * textSize, 'OrangeRed')}

      {ueAngular &&
        ueAngular !== u1 &&
        renderLine(0, ueAngular, 0, 'DarkViolet')}

      {ueDoubleBend &&
        renderLine(ueAngular, ueAngular + ueDoubleBend, 0, 'DodgerBlue')}

      {u2 &&
        u2 !== u1 &&
        renderLine(ueAngular + ueDoubleBend, u1, 0, 'SeaGreen')}

      {renderValueLabel(u1 / 2, 0.1 * textSize, result.u1, 'OrangeRed', 'u1')}
      {ueAngular &&
        ueAngular !== u1 &&
        renderValueLabel(
          ueAngular / 2,
          0,
          result.ue_angular,
          'DarkViolet',
          'ue_angular'
        )}
      {ueDoubleBend &&
        renderValueLabel(
          ueAngular + ueDoubleBend / 2,
          0,
          result.ue_double_bend_value,
          'DodgerBlue',
          'ue_double_bend_value'
        )}
      {u2 &&
        u2 !== u1 &&
        renderValueLabel(
          ueAngular + ueDoubleBend + u2 / 2,
          0,
          result.u2_value,
          'SeaGreen',
          'u2_value'
        )}
    </group>
  );
}

export default UpperEndView;
